import { ANALYZE_FLYOUT, AnalyzeFlyoutAction } from 'b2b-apps/shop/analytics/redux';

export const analyzeFlyout = (
  path: string[],
  url: string,
  position: number,
): AnalyzeFlyoutAction => ({
  type: ANALYZE_FLYOUT,
  payload: {
    path,
    url,
    position,
  },
});
